import { isDevelopment } from "js/config";
import { getTemplates, templateCategories } from "common/slideTemplates";

const slideTemplates = getTemplates(isDevelopment);
const SlidePlaceholderTemplate = slideTemplates["slidePlaceholder"];

const allTemplates = Object.values(slideTemplates);
const categorizedTemplates = templateCategories.reduce((acc, category) => {
    acc[category.id] = allTemplates.filter(val => val.category.includes(category.id) && !val.hideTemplate);
    return acc;
}, {});

window.categorizedTemplates = categorizedTemplates;

export {
    slideTemplates,
    templateCategories,
    SlidePlaceholderTemplate,
    categorizedTemplates
};
